import { render, staticRenderFns } from "./SanityTestimonials.vue?vue&type=template&id=8922d444"
import script from "./SanityTestimonials.vue?vue&type=script&lang=js"
export * from "./SanityTestimonials.vue?vue&type=script&lang=js"
import style0 from "./SanityTestimonials.vue?vue&type=style&index=0&id=8922d444&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports